import React from 'react';
import Figure1 from '../Images/Figure1.jpg';
import Figure2 from '../Images/Figure2.jpg';
import Figure3 from '../Images/Figure3.jpg';
import Figure4 from '../Images/Figure4.jpg';
import Figure5 from '../Images/Figure5.jpg';
import Figure6 from '../Images/Figure6.jpg';
import Figure6nd from '../Images/Figure6-2.jpg';
import Figure7 from '../Images/Figure7.jpg';
import Figure8 from '../Images/Figure8.jpg';
import Figure9 from '../Images/Figure9.jpg';
import Figure10 from '../Images/Figure10.jpg';
import Figure11 from '../Images/Figure11.jpg';
import Figure12 from '../Images/Figure12.jpg';
import Figure13 from '../Images/Figure13.jpg';
import Figure14 from '../Images/Figure14.jpg';
import Figure14nd from '../Images/Figure14-1.jpg';
import Figure14rd from '../Images/Figure14-2.jpg';
import Figure14ed from '../Images/Figure14-3.jpg';
import Figure14fourth from '../Images/Figure14-4.jpg';
import Figure14fifth from '../Images/Figure14-5.jpg';
import Figure15 from '../Images/Figure15.jpg';
import Figure16 from '../Images/Figure16.jpg';
import Figure17 from '../Images/Figure17.jpg';
import Figure18 from '../Images/Figure18.jpg';
import Figure19 from '../Images/Figure19.jpg';
import Figure20 from '../Images/Figure20.jpg';
import Figure21 from '../Images/Figure21.jpg';
import Figure22 from '../Images/Figure22.jpg';
import Figure23 from '../Images/Figure23.jpg';
import Figure24 from '../Images/Figure24.jpg';
import Figure25 from '../Images/Figure25.jpg';
import Figure26 from '../Images/Figure26.jpg';
import Figure27 from '../Images/Figure27.jpg';

const Figures = [


    {
        id: 1,
        Image: Figure1,
        FigureDescription: 'Figure 1. Regional geological map of the Bagdad-Chase Mine and surrounding area. From Bortungno and Spittler, 1986.'
    },

    {
        id: 2,
        Image: Figure2,
        FigureDescription: 'Figure 2. Regional topographic map showing the Bagdad-Chase mines in relation to other mines in the Northern Bullion Mountains.Scale 1: 200,000..'
    },

    {
        id: 3,
        Image: Figure3,
        FigureDescription: 'Figure 3. Regional topographic map of the Bagdad-Chase mine. Scale 1:100,000.'
    },

    {
        id: 4,
        Image: Figure4,
        FigureDescription: 'Figure 4. Regional geological map of the Bagdad-Chase Mine and surrounding area. From Phelps and others, 2012.'
    },

    {
        id: 5,
        Image: Figure5,
        FigureDescription: 'Figure 5. Topographic map of the Bagdad-Chase mine and other mines in the Northern Bullion Mountains. Scald 1:24,000.'
    },

    {
        id: 6,
        Image: Figure6,
        FigureDescription: 'Figure 6. Area geological map of the Bagdad-Chase Mine and surrounding area. From Dibblee, 1967d.'
    },

    {
        id: 7,
        Image: Figure6nd,
        FigureDescription: ''
    },

    {
        id: 8,
        Image: Figure7,
        FigureDescription: 'Figure 7. Topographic map of the Ragtown, Stedman and Bagdad-Chase areas showing mill sites.'
    },
    {
        id: 9,
        Image: Figure8,
        FigureDescription: 'Figure 8. Area geologic map. From Dibblee and Minch, 2008f.'
    },

    {
        id: 10,
        Image: Figure9,
        FigureDescription: 'Figure 9. Mine geology map of the Bagdad-Chase Mine and surrounding area. From Collier and Vanderpool, 1957.'
    },

    {
        id: 11,
        Image: Figure10,
        FigureDescription: 'Figure 10. Mine geology map of the Bagdad-Chase Mine and surrounding area. From Collier and Vanderpool, 1957.'
    },

    {
        id: 12,
        Image: Figure11,
        FigureDescription: 'Figure 11. Aerial photograph of the Bagdad-Chase fault lineament.'
    },

    {
        id: 13,
        Image: Figure12,
        FigureDescription: 'Figure 12. Aerial photograph of the southern Bagdad-Chase mine. From ESRI.'
    },

    {
        id: 14,
        Image: Figure13,
        FigureDescription: 'Figure 13. Topographic map of the Stedman and Bagdad-Chase Areas.'
    },

    {
        id: 15,
        Image: Figure14,
        FigureDescription: 'Figure 14. Aerial photograph of the Bagdad-Chase Open Pit and Ore Stockpile'
    },

    {
        id: 16,
        Image: '',
        FigureDescription: 'IMAGES (uncaptioned, photographer unknown, obtained from internet May 21, 2020)'
    },
    {
        id: 17,
        Image: Figure14nd,
        FigureDescription: ''
    },

    {
        id: 18,
        Image: Figure14rd,
        FigureDescription: ''
    },

    {
        id: 19,
        Image: Figure14ed,
        FigureDescription: ''
    },

    {
        id: 20,
        Image: Figure14fourth,
        FigureDescription: ''
    },

    {
        id: 21,
        Image: Figure14fifth,
        FigureDescription: ''
    },

    {
        id: 22,
        Image: '',
        FigureDescription: 'Photographs by Gregg Wilkerson and Derik Lindberg, May 24, 2020:'
    },

    {
        id: 23,
        Image: Figure15,
        FigureDescription: 'Figure 15. Ore stockpile with azurite, malachite, turquoise, chalcanthite, iron oxides and jasper.'
    },

    {
        id: 24,
        Image: Figure16,
        FigureDescription: 'Figure 16. Jasperoid rhyodacite breccia.'
    },

    {
        id: 25,
        Image: Figure17,
        FigureDescription: 'Figure 17. Hydrothermally altered rhyodacite.'
    },

    {
        id: 26,
        Image: Figure18,
        FigureDescription: 'Figure 18. Bagdad-Chase mill.'
    },

    {
        id: 27,
        Image: Figure19,
        FigureDescription: 'Figure 19. Bagdad-Chase Mill tailings.'
    },

    {
        id: 28,
        Image: Figure20,
        FigureDescription: 'Figure 20. Bagdad-Chase mill ruins.'
    },

    {
        id: 29,
        Image: Figure21,
        FigureDescription: 'Figure 21. Stedman mill ruins.'
    },

    {
        id: 30,
        Image: Figure22,
        FigureDescription: 'Figure 22. Stedman Mill ruins.'
    },

    {
        id: 31,
        Image: Figure23,
        FigureDescription: 'Figure 23. Iron leach tank contents. A wooden tank that one contained the leachate has disappeared.'
    },

    {
        id: 32,
        Image: Figure24,
        FigureDescription: 'Figure 24. Iron leaching remnants. Copper -bearing solutions were pumped into a tank with watch springs and other iron shavings to precipitate copper.'
    },

    {
        id: 33,
        Image: Figure25,
        FigureDescription: 'Figure 25. Mound of white reactant. Composition unknown.'
    },

    {
        id: 34,
        Image: Figure26,
        FigureDescription: 'Figure 26. White reactant. Composition unknown'
    },

    {
        id: 35,
        Image: Figure27,
        FigureDescription: 'Figure 27. Stedman mill tailings.'
    },

]

const Maps = () => {
    return (
        <div>
            <div className='text-lg font-bold my-10'>MAPS</div>
            {Figures.map(Figure => (
                <div key={Figure.id} className='my-5'>
                    {Figure.Image && ( // Only render the image if it exists
                        <div className=''>
                            <img src={Figure.Image} alt={Figure.FigureDescription} title={Figure.FigureDescription} className='mx-auto' />
                        </div>
                    )}
                    <div className='pt-2 text-center'>
                        <em>{Figure.FigureDescription}</em>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Maps